import React, {useState, useEffect} from 'react'
import {buildImageObj} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'
import DropdownSelect from './dropdownSelect'
import PortableText from './portableText'
import AccordionLinkFile from './accordion-link-file'
import Gallery from './gallery'
import AccordionDetailPageList from './accordion-detailPageList'
import {isUserInRegion} from '../services/auth'


const AccordionBuildingLightbox = ({items, userRegion}) => {
    let filteredItem = items.filter(item => isUserInRegion(userRegion, item.region))

    return (
        <div className="pt-3">

            {/* {console.log('---> accordion > sub-section: ', items)} */}

            {
                filteredItem && filteredItem.length > 0 &&
                filteredItem.map((section, i) => (
                    <div key={i} className="row">
                            
                        {(()=>{
                            // display gallery
                            let images = section.files && section.files.map(item => {
                                if(item._type === 'mainImage'){
                                    return {
                                        original: item.asset ? item.asset.url : '',
                                        thumbnail: item.asset ? item.asset.url + '?w=250&h=150&fit=max' : ''
                                    }
                                }
                                else if(item._type === 'video' && item.file && item.file.asset.mimeType === 'video/mp4' && isUserInRegion(userRegion, item.region)){
                                    return {
                                        original: item.thumbnail && item.thumbnail.asset ? item.thumbnail.asset.url : '',
                                        thumbnail: item.thumbnail && item.thumbnail.asset ? item.thumbnail.asset.url + '?w=250&h=150&fit=max' : '',
                                        embedUrl: item.file && item.file.asset ? item.file.asset.url : '',
                                        videoType: 'selfHost'
                                    }
                                }
                            })

                            let filterdImage = images.filter(x => x)
                            if(filterdImage.length > 0){
                                return (
                                    <div className="col-12 col-md-7">
                                        <Gallery items={filterdImage} />
                                    </div>
                                )
                            }
                        })()}

                        <div className="col-12 col-md-5">
                            <PortableText blocks={section._rawDecription} />
                            <AccordionLinkFile items={section.sectionLinks} userRegion={userRegion} />
                            {
                                section.sectionDetailPages.length > 0 && 
                                <>
                                    <h6 className="mt-4">{section.subTitle + ':' || ''}</h6>
                                    <AccordionDetailPageList items={section.sectionDetailPages} contentType='buildings' userRegion={userRegion} />
                                </>
                            }
                        </div>

                    </div>
                ))
            }

        </div>
    )
}

export default AccordionBuildingLightbox
